import { Component, OnInit, Input } from '@angular/core';
import { CambioPiano } from '../../../models/fisso';
@Component({
  selector: 'alg-change-plan-info-contract',
  templateUrl: './alg-change-plan-info-contract.component.html',
  styleUrls: ['./alg-change-plan-info-contract.component.scss'],
})
export class AlgChangePlanInfoContractComponent implements OnInit {
  @Input() reverse: boolean;
  @Input() changePlan: CambioPiano;

  public typeProductName: string;
  public isProductGreen: boolean;
  constructor() {}

  ngOnInit() {
    if (this.changePlan.isLight && !this.changePlan.isGas) {
      this.typeProductName = 'Mono Luce';
    }

    if (!this.changePlan.isLight && this.changePlan.isGas) {
      this.typeProductName = 'Mono Gas';
    }

    if (this.changePlan.isDual) {
      this.typeProductName = 'Dual';
    }

    this.isProductGreen =
      this.changePlan.NewProductName.toUpperCase().includes('ECOLOGICA') ||
      this.changePlan.greenEnergy === true
        ? true
        : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-info-contract/alg-change-plan-info-contract.component.ts